import { connect } from 'react-redux';
import TermsAndConditionsPage from './termsandconditionspage';

const mapState = ({ authentication }) => ({
  user: authentication.user,
});

const mapDispatch = {
};

export default connect(
  mapState,
  mapDispatch,
)(TermsAndConditionsPage);
